import classnames from "classnames";
import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import getEmailUsUrl from "@/utils/getEmailUsUrl";
import { trackMonetateEvent } from "@/context/MonetateContext";
import { OrdersOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OrdersOutlined";
import { useFeatureFlag } from "@/context/FeatureFlagContext";

import styles from "./contact-email.module.scss";

const unavailableEmailOption = () => (
  <div>
    <br />
    <p>
      <strong>Currently unavailable</strong>
    </p>
    <p>You can still get in touch by calling our Customer Service team.</p>
  </div>
);

const availableEmailOption = location => (
  <>
    <p>
      Please note: if you prefer to <Link href={getEmailUsUrl(location)}>email us</Link>, it may take up to 24 hours for
      a response and longer for us to resolve your query.
    </p>
    <p>We recommend phone for a quicker response and resolution.</p>
  </>
);

function ContactEmail({ className, config: { open }, location }) {
  const showNewProminentLiveChat = useFeatureFlag("show_new_prominent_live_chat");
  const router = useRouter();

  const handleEmailUsButtonClick = () => {
    trackMonetateEvent("email_contact_rate");
    if (router?.query?.dt === "problemsWithProduct-other") router.push("/email-us?t=problemsWithProduct-problemsOther");
    else router.push("/email-us?t=deliveryQuery-damagedOnDeliveryNonFurniture-online");
  };

  return (
    <>
      {showNewProminentLiveChat ? (
        <div className={classnames(className, styles["contact-email"])} data-test="container-email">
          <h4 className={styles["contact-email-us__title"]}>Use our online form</h4>
          <p>1. Submit your photos using our online form</p>
          <p>2. We’ll be in touch to explain what to do next</p>
          <p>3. This usually includes a quick call with our team</p>
          <button
            type="button"
            className={classnames(styles["email-us-button"])}
            data-test="email-us-button"
            onClick={handleEmailUsButtonClick}
          >
            <span className={styles.emailIcon}>
              <OrdersOutlined />
              Use online form
            </span>
          </button>
        </div>
      ) : (
        <div className={classnames(className, styles["contact-email"])} data-test="container-email">
          <h4 className={styles["contact-email__title"]}>Email</h4>
          {open ? availableEmailOption(location) : unavailableEmailOption()}
        </div>
      )}
    </>
  );
}

export default ContactEmail;
